import { render, staticRenderFns } from "./layout-contact-block-row.vue?vue&type=template&id=cec9c44c&scoped=true&"
import script from "./layout-contact-block-row.vue?vue&type=script&lang=js&"
export * from "./layout-contact-block-row.vue?vue&type=script&lang=js&"
import style0 from "./layout-contact-block-row.vue?vue&type=style&index=0&id=cec9c44c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cec9c44c",
  null
  
)

export default component.exports